const DIRECT_QUANTITY_KEYS = [
  'quantity',
  'qty',
  'requestedQuantity',
  'requestQuantity',
  'requiredQuantity',
  'neededQuantity',
  'quantityNeeded',
  'quantityRequired',
  'amount',
];

const DIRECT_UNIT_KEYS = [
  'quantityUnit',
  'requestedQuantityUnit',
  'requestQuantityUnit',
  'unit',
  'unitLabel',
  'uom',
  'package',
  'packaging',
  'container',
  'containerType',
];

const getFirstDefinedValue = (data, keys) => {
  return keys.reduce((selected, key) => {
    return selected != null && selected !== '' ? selected : data?.[key];
  }, null);
};

export const toPositiveInteger = value => {
  if (typeof value === 'number') {
    return Number.isInteger(value) && value > 0 ? value : null;
  }

  if (value && typeof value.toNumber === 'function') {
    return toPositiveInteger(value.toNumber());
  }

  if (typeof value === 'string' || (value && typeof value.toString === 'function')) {
    const normalized = `${value}`.trim().replace(/,/g, '');
    const integerMatch = normalized.match(/\b[1-9]\d*\b/);
    return integerMatch ? Number.parseInt(integerMatch[0], 10) : null;
  }

  return null;
};

const humanizeUnit = value => {
  return value && typeof value === 'string' ? value.replace(/[-_]/g, ' ') : null;
};

export const formatQuantityLabel = (quantity, unit) => {
  const quantityString = quantity != null && quantity !== '' ? `${quantity}`.trim() : null;
  const unitString = unit != null && unit !== '' ? `${unit}`.trim() : null;
  const quantityAlreadyHasUnit = unitString
    ? quantityString?.toLowerCase().includes(unitString.toLowerCase())
    : false;

  return quantityString && unitString && !quantityAlreadyHasUnit
    ? `${quantityString} ${unitString}`
    : quantityString;
};

export const getListingQuantityValue = (listing, options = {}) => {
  const { includeStock = true } = options;
  const publicData = listing?.attributes?.publicData || {};
  const metadata = listing?.attributes?.metadata || {};
  const listingData = { ...metadata, ...publicData };
  const rawQuantity = getFirstDefinedValue(listingData, DIRECT_QUANTITY_KEYS);
  const stockQuantity = listing?.currentStock?.attributes?.quantity;

  return toPositiveInteger(rawQuantity) || (includeStock ? toPositiveInteger(stockQuantity) : null);
};

export const getListingQuantityUnit = listing => {
  const publicData = listing?.attributes?.publicData || {};
  const metadata = listing?.attributes?.metadata || {};
  const listingData = { ...metadata, ...publicData };
  return humanizeUnit(getFirstDefinedValue(listingData, DIRECT_UNIT_KEYS));
};

export const getListingQuantityLabel = listing => {
  const quantity = getListingQuantityValue(listing);
  return formatQuantityLabel(quantity, getListingQuantityUnit(listing));
};
